module.exports = __webpack_public_path__ + "static/loading-2ce70d74099947b81a6007d3e7920f7e.gif";